module.exports = __webpack_public_path__ + "static/media/footerShape.d41d81f9.png";